import React from 'react';

const MultipleRequestItemPill = ({
  actions
}: {
  actions: { label: string; onClick: () => void }[];
}) => {
  return (
    <div className='rounded-full bg-white px-5 py-4 flex items-center gap-5 shadow-lg absolute bottom-4 left-1/2 -translate-x-1/2'>
      {actions?.map((action) => (
        <button
          className='bg-[#F2F2F2] text-[#585F68] rounded-full px-3 text-xs py-2'
          key={action.label}
          onClick={action.onClick}>
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default MultipleRequestItemPill;
